import PieChartRow from './PieChartRow'

export default PieChartRow
